/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import axios from 'axios';
import { SUB_PATH } from '../../public/config.json';


export const OK: number = 200;
export const FORBIDDEN: number = 403;
export const UNAUTHORIZED: number = 401;

let pathExtension = '';
if (SUB_PATH && SUB_PATH !== 'PRODUCTION'.concat('_SUB_PATH')) {
  pathExtension = `${SUB_PATH}`;
}

export const BASE_URL: string = `${window.location.protocol}//${window.location.hostname}`;

export const PATH_EXTENSION = pathExtension;

// Determines whether the connection is on HTTPS or HTTP
export const isSecure: boolean = window.location.protocol === 'https:';

export const SECURE_PORT = '443';

export const SERVICES = new Map();
SERVICES.set('packagemanager', 'packagemanager');
SERVICES.set('userservice', 'userservice');
SERVICES.set('flowmanager', 'flowmanager');
SERVICES.set('gridmanager', 'gridmanager');

export const PORTS = new Map();
PORTS.set('packagemanager', isSecure ? SECURE_PORT : '8087');
PORTS.set('userservice', isSecure ? SECURE_PORT : '9000');
PORTS.set('flowmanager', isSecure ? SECURE_PORT : '9002');
PORTS.set('gridmanager', isSecure ? SECURE_PORT : '8080');
PORTS.set('brick-store', isSecure ? SECURE_PORT : '9876');

export const httpClient = axios.create({
  baseURL: '',
  withCredentials: true,
  xsrfCookieName: 'token',
});
